import React from 'react';
const DivElement = React.forwardRef(({ id, className, style, onClick, children }, ref) => {
    return (React.createElement("div", { id: id, className: className, ref: ref, style: style, onClick: onClick }, children));
});
export default DivElement;
